import shave from 'shave';
import du from '../utils/dom-utilities';
import CONF from '../utils/conf';

/* eslint-disable max-statements */
/**
 * boxTruncate - Truncate box content based on content height ratio
 * e.g: if my content represent more than 50% of the ratio i want to truncate it
 *
 * @param {DOMElement} boxContent
 * @param {DOMElement} boxTitle
 * @param {Number} boxHeight
 * @param {String} boxContentText
 * @param {String} boxTitleContentText
 * @param {Boolean} isScroll
 */
const boxTruncate = (
        boxContent = null,
        boxTitle = null,
        boxHeight = null,
        boxContentText = null,
        boxTitleContentText = null,
        isScroll = false
    ) => {
        if (!boxContent || !boxTitle || !boxHeight || !boxContentText || !boxTitleContentText) {
            return;
        }

        const isShaveBoxContent = boxContent.querySelector('.js-shave') ? true : false;
        const isShaveBoxTitle = boxTitle.querySelector('.js-shave') ? true : false;

        if (isShaveBoxContent) {
            boxContent.textContent = boxContentText;
        }

        if (isShaveBoxTitle) {
            boxTitle.textContent = boxTitleContentText;
        }

        const boxTitleHeight = boxTitle.offsetHeight;
        const contentHeightRatio = (boxContent.offsetHeight + boxTitleHeight) / boxHeight;

        if (contentHeightRatio >= 0.50 ) {
            isScroll ? shave(boxContent, 120) : shave(boxContent, 100);

            if (boxTitleHeight > 70) {
                shave(boxTitle, 90);
            }
        }
};

export default function () {
    const boxes = du.queryAll('.card-flex');

    if (!boxes || boxes.length === 0) {
        return;
    }

    boxes.forEach((box) => {
        const boxContent = box.querySelector('.card-flex__description');
        const boxTitle = box.querySelector('.card-flex__title');

        if (!boxContent || !boxTitle) {
            return;
        }

        const boxContentText = boxContent.textContent;
        const boxTitleContentText = boxTitle ? boxTitle.textContent : null;

        // Add 5px to conf.mq.sm in order to prevent bug on firefox
        if (window.innerWidth > (CONF.mq.sm - 5)) {
            // Fix a bug with safari and mosaic DOM manipulation
            // When page load, truncated function finished before mosaic paint is fully accomplished
            setTimeout(() => {
                boxTruncate(boxContent, boxTitle, box.offsetHeight, boxContentText, boxTitleContentText);
            }, 500);
        }

        du.onEvent(window, 'optimized-resize', du.setThrottle(() => {
            // Add 5px to conf.mq.sm in order to prevent bug on firefox
            if (window.innerWidth > (CONF.mq.sm - 5)) {
                boxTruncate(boxContent, boxTitle, box.offsetHeight, boxContentText, boxTitleContentText, true);
            } else {
                const isShaveBoxContent = boxContent.querySelector('.js-shave') ? true : false;
                const isShaveBoxTitle = boxTitle.querySelector('.js-shave') ? true : false;

                if (isShaveBoxContent) {
                    boxContent.textContent = boxContentText;
                }

                if (isShaveBoxTitle) {
                    boxTitle.textContent = boxTitleContentText;
                }
            }

        }, 200));
    });
};
/* eslint-enable max-statements */



// WEBPACK FOOTER //
// ./src/main/js/components/truncate.js